import { type ReactNode, useEffect } from 'react';

/** Drawer lateral simples (abrir/fechar 150ms — UX-PAINEL-INTERNO §0.6). */
export function Drawer({
  aberto,
  titulo,
  aoFechar,
  children,
}: {
  aberto: boolean;
  titulo: string;
  aoFechar: () => void;
  children: ReactNode;
}): ReactNode {
  useEffect(() => {
    if (!aberto) return;
    const esc = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') aoFechar();
    };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [aberto, aoFechar]);

  if (!aberto) return null;
  return (
    <div className="fixed inset-0 z-40 flex justify-end">
      <div className="absolute inset-0 bg-black/30" onClick={aoFechar} aria-hidden />
      <div
        role="dialog"
        aria-modal="true"
        aria-label={titulo}
        className="relative flex w-[420px] max-w-full flex-col gap-4 overflow-y-auto border-l border-linha bg-superficie-alta p-5"
      >
        <h2 className="font-display text-bloco-titulo font-bold uppercase text-tinta-forte">
          {titulo}
        </h2>
        {children}
      </div>
    </div>
  );
}
